import React, { useState, useEffect, useRef } from "react";
import api from '../../../../../../../api';
import { Button, Checkbox, Table, Input, TextArea, Dropdown, Header, Modal, Icon, Dimmer, Loader, Message } from "semantic-ui-react";
import styles from "./DataConnect.module.css";
import "./DataConnectPage.css";

const DublicateDataLayerModel = ({ open, onClose, preformData, updateConnectiontools, setshowErrortype, connections, workspace_id }) => {
    const [formData, setFormData] = useState({
        ...preformData,
        connectionName: `Copy_${preformData.connectionName}`,
    });
    const [loading, setLoading] = useState(false);
    const [editId, seteditId] = useState(null);
    const [subitStatus, setSubmitStatus] = useState(false);
    const [showErrortypeModal, setshowErrortypeModal] = useState({ type: "", title: "", message: "" });
    const [newProperty, setNewProperty] = useState({
        name: "",
        description: "",
        type: "string",
    });
    const [timezone, settimezone] = useState(null);
    const [selectedtimezone, setselectedtimezone] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false); // Added to track submission state
    const modalTopRef = useRef(null);

    useEffect(() => {
        api.botbuilder.gettimezoneHourConfigration().then((res) => {
            settimezone(res.timezone ? res.timezone : []);
        });
    }, []);

    useEffect(() => {
        if (showErrortypeModal.message) {
            setTimeout(() => {
                setshowErrortypeModal({ type: "", title: "", message: "" });
            }, 7000);
            if (modalTopRef.current) {
                modalTopRef.current.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [showErrortypeModal]);

    const handleInputChange = (e, data = null) => {
        const { name, value, type, checked } = e.target;
        if (name === 'connectionName') {
            if (!/^[a-zA-Z0-9_]+$/.test(value) && value.trim() !== '') {
                setshowErrortypeModal({
                    type: "negative",
                    title: "Failed!",
                    message: "Connection Name should not contain any special characters except _"
                });
                return;
            }
        }
        if (name !== undefined) {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [data.name]: data.checked,
            }));
        }
    };

    const handlePropertyChange = (key, value) => {
        setNewProperty((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const renderTimezone = (selectedhour) => {
        let timezoneArray = Object.entries(timezone);
        let stateTemp = { ...selectedhour };
        let timezons = timezoneArray.map((timezone) => {
            return {
                key: timezone[1],
                text: timezone[0] + timezone[1],
                value: timezone[1]
            };
        });
        return {
            timezone: timezons,
            stateTemp: stateTemp
        };
    };

    const handleAddProperty = () => {
        if (editId !== null) {
            if (newProperty.name !== undefined && newProperty.description !== undefined && newProperty.name.trim()) {
                if (newProperty.name.trim() !== '' && newProperty.description.trim() !== "") {
                    formData.properties[editId] = newProperty;
                    setFormData((prev) => ({
                        ...prev,
                        properties: [...prev.properties],
                    }));
                    setNewProperty({ name: "", description: "", type: "string" });
                    seteditId(null);
                } else {
                    setshowErrortypeModal({
                        type: "negative",
                        title: "Failed!",
                        message: "Name or Description should not be blank."
                    });
                }
            } else {
                setshowErrortypeModal({
                    type: "negative",
                    title: "Failed!",
                    message: "Name or Description should not be blank."
                });
            }
            return;
        } else {
            seteditId(null);
            if (newProperty.name !== undefined && newProperty.description !== undefined && newProperty.name.trim()) {
                if (newProperty.name.trim() !== '' && newProperty.description.trim() !== "") {
                    setFormData((prev) => ({
                        ...prev,
                        properties: [...prev.properties, newProperty],
                    }));
                    setNewProperty({ name: "", description: "", type: "string" });
                } else {
                    setshowErrortypeModal({
                        type: "negative",
                        title: "Failed!",
                        message: "Name and description should not be empty."
                    });
                }
            } else {
                setshowErrortypeModal({
                    type: "negative",
                    title: "Failed!",
                    message: "Name or Description should not be blank."
                });
            }
        }
    };

    const handleDeleteProperty = (id) => {
        formData.properties.splice(id, 1);
        setFormData((prev) => ({
            ...prev,
            properties: [...prev.properties],
        }));
    };

    const handleEditProperty = (id) => {
        let property = formData.properties[id];
        setNewProperty(property);
        seteditId(id);
    };

    const setSelectedProperties = (value) => {
        setFormData((prev) => ({
            ...prev,
            required: value,
        }));
    };

    const svdb = (value) => {
        setFormData((prev) => ({ ...prev, databasefortool: value }));
    };

    const setTimezone = (timezone) => {
        setselectedtimezone(timezone);
    };

    useEffect(() => {
        if (formData?.selectedtimezone) {
            setselectedtimezone(formData.selectedtimezone);
        }
    }, [formData]);

    const handleSubmit = async () => {
        // Prevent multiple submissions
        if (isSubmitting) return;
        
        const { connectionName, description, properties } = formData;
        if (!connectionName.trim()) {
            setshowErrortypeModal({
                type: "negative",
                title: "Failed!",
                message: "Name and description should not be empty."
            });
            return;
        }
        if (!description.trim()) {
            setshowErrortypeModal({
                type: "negative",
                title: "Failed!",
                message: "Description is required!"
            });
            return;
        }
        if (properties.length === 0) {
            setshowErrortypeModal({
                type: "negative",
                title: "Failed!",
                message: "Properties are required!"
            });
            return;
        }
        
        try {
            setIsSubmitting(true);
            setLoading(true);
            setSubmitStatus(true);
            
            let payload = { ...formData, workspace_id: atob(workspace_id), selectedtimezone: selectedtimezone };
            const res = await api.DatalayerandTooling.saveNewturboTool(payload);
            
            if (res.status === true || res.status === 200) {
                updateConnectiontools(workspace_id);
                setshowErrortype({
                    type: "positive",
                    title: "Success!",
                    message: formData.id == null ? "Tool has been copied successfully." : "Tool has been updated successfully."
                });
            } else {
                setshowErrortype({
                    type: "negative",
                    title: "Failed!",
                    message: "Something went wrong."
                });
            }
        } catch (error) {
            setshowErrortype({
                type: "negative",
                title: "Failed!",
                message: error.message
            });
        } finally {
            setIsSubmitting(false);
            setLoading(false);
            setSubmitStatus(true);
            onClose();
        }
    };

    const messageAlert = () => {
        if (showErrortypeModal.title !== "") {
            return (
                showErrortypeModal.type === 'negative' ?
                    <Message negative>
                        <Message.Header>{showErrortypeModal.title}</Message.Header>
                        <p>{showErrortypeModal.message}</p>
                    </Message> :
                    <Message positive>
                        <Message.Header>{showErrortypeModal.title}</Message.Header>
                        <p>{showErrortypeModal.message}</p>
                    </Message>
            );
        }
        return null;
    };

    return (
        <>
            <div ref={modalTopRef}></div>
            <Dimmer
                className={styles.newLoader}
                active={loading}
                inverted
            >
                <Loader>Loading...</Loader>
            </Dimmer>
            <div className="datlayermodal">
                <Modal open={open} onClose={onClose} size="small" className="custom-modal">
                    <Modal.Content>
                        <button
                            type="button"
                            className="close linear-gradient"
                            onClick={onClose}
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            X
                        </button>
                        <div className="modal-header">
                            <h5 className="modal-title">Confirm your action</h5>
                        </div>
                        {messageAlert()}
                        <p className="custom-modal-content">Are you sure you want to copy this connection?</p>
                    </Modal.Content>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
                            onClick={onClose}
                            data-dismiss="modal"
                        >
                            <span>No</span>
                        </button>
                        <button
                            type="button"
                            onClick={handleSubmit}
                            className="btn linear-gradient yr-submitbtn btn-sm"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Yes' : 'Yes'}
                        </button>
                    </div>
                </Modal>
            </div>
        </>
    );
};

export default DublicateDataLayerModel;